export default __webpack_public_path__ + "static/media/blood-pressure.3998cfeb.svg";